module.exports = __webpack_public_path__ + "img/icon-stt.89196ded.svg";